import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Hook personalizado para adicionar funcionalidade "voltar ao topo" a qualquer botão
export const useScrollToTop = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return scrollToTop;
};

// Hook para detectar se o usuário rolou a página
export const useScrollPosition = (threshold = 300) => {
  const [isScrolled, setIsScrolled] = React.useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      setIsScrolled(scrollTop > threshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return isScrolled;
};

// Hook para rolar para o topo quando a rota mudar
export const useScrollToTopOnRouteChange = (options = {}) => {
  const { 
    behavior = 'smooth', 
    excludeRoutes = [],
    delay = 0,
    enabled = true 
  } = options;
  
  const { pathname } = useLocation();

  useEffect(() => {
    if (!enabled) return;

    // Verificar se a rota atual deve ser excluída
    const shouldSkip = excludeRoutes.some(route => 
      pathname.startsWith(route)
    );

    if (shouldSkip) return;

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: behavior
      });
    };

    if (delay > 0) {
      const timer = setTimeout(scrollToTop, delay);
      return () => clearTimeout(timer);
    } else {
      scrollToTop();
    }
  }, [pathname, behavior, excludeRoutes, delay, enabled]);
};
